import { useInView } from './hooks';

const ERP = [
  { label: 'SAP', sub: 'ERP', badge: 'SAP', color: '#1F4E9A' },
  { label: 'Logo ERP', sub: 'ERP', badge: 'LOGO', color: '#C8102E' }
];
const XL = [
  ...[1, 2, 3, 4, 5].map(i => 'Ofis Bilgisayarı ' + i),
  ...[1, 2].map(i => 'Şube Bilgisayarı ' + i)
];
const OUT = [
  ['Teklif PDF’i', 'Kurumsal şablonla'],
  ['ERP’ye kayıt', 'Onaydan sonra yazılır'],
  ['Denetim kaydı', 'Her adım izlenir']
];

// Her Excel kaynağı bir bilgisayar ikonu: ekranda Excel simgesi.
const Pc = () => (
  <svg className="so-pc" viewBox="0 0 64 58" aria-hidden="true">
    <rect x="3" y="2" width="58" height="40" rx="6" fill="#fff" stroke="#34435A" strokeWidth="2.5" />
    <rect x="9" y="8" width="46" height="28" rx="3" fill="#EAF6EF" />
    <rect x="22" y="11" width="20" height="20" rx="4" fill="#107C41" />
    <path d="M28 16.5l8 10M36 16.5l-8 10" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M26 42v8M38 42v8" stroke="#34435A" strokeWidth="2.5" />
    <rect x="17" y="50" width="30" height="5" rx="2.5" fill="#34435A" />
  </svg>
);

const Tick = () => <svg className="so-tick" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M8 12.3l2.7 2.7L16 9.5" /></svg>;
const CHANNELS = [
  ['Komut arayüzü', (
    <svg viewBox="0 0 32 32" aria-hidden="true"><rect width="32" height="32" rx="9" fill="#0E1A2B" /><rect x="6" y="8" width="20" height="14" rx="3" fill="none" stroke="#fff" strokeWidth="1.8" /><path d="M10 13l3 2.5-3 2.5M15.5 18.5h5" fill="none" stroke="#FF7B86" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 25h8" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" /></svg>
  )],
  ['WhatsApp', (
    <svg viewBox="0 0 32 32" aria-hidden="true"><rect width="32" height="32" rx="9" fill="#25D366" /><path d="M16 6.5a9.5 9.5 0 00-8.2 14.3L6.5 25.5l4.8-1.2A9.5 9.5 0 1016 6.5z" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinejoin="round" /><path d="M12.4 12.2c.3-.7.8-.6 1.1-.6.3 0 .5.5.8 1.2.2.5-.4.9-.6 1.2-.1.2 0 .5.5 1.1.9 1 1.7 1.4 2.1 1.6.4.2.6 0 .8-.2.3-.4.5-.8.9-.7.4.2 1.3.6 1.4.9.1.3-.1 1.1-.9 1.5-.8.4-2.1.5-4-.6-1.9-1.1-3.1-3-3.4-3.8-.3-.8-.1-1.9.3-2.5z" fill="#fff" /></svg>
  )],
  ['Telegram', (
    <svg viewBox="0 0 32 32" aria-hidden="true"><rect width="32" height="32" rx="9" fill="#229ED9" /><path d="M25 8.2L6.8 15.4c-.8.3-.8 1.4.1 1.7l4.6 1.5 1.8 5.6c.2.6.9.8 1.4.4l2.6-2.2 4.6 3.4c.6.4 1.4.1 1.5-.7L26.3 9.4c.2-.9-.7-1.5-1.3-1.2z" fill="#fff" /><path d="M11.6 18.3l10.4-6.6-8 7.6-.4 3.5z" fill="#B9DDF2" /></svg>
  )]
];

const Chevron = () => <svg className="so-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>;
const Link = ({ i }) => <div className="so-link" style={{ '--i': i }} aria-hidden="true"><span /></div>;

export default function SystemOverview() {
  const [ref, seen] = useInView(0.2);
  return (
    <div ref={ref} className={'so' + (seen ? ' in' : '')}>
      <div className="so-card so-src" style={{ '--i': 0 }}>
        <div className="so-grp">ERP sistemleri</div>
        <div className="so-grid">
          {ERP.map(n => (
            <div key={n.label} className="so-item">
              <span className="so-badge" style={{ background: n.color, fontSize: n.badge.length > 3 ? 9 : 11 }}>{n.badge}</span>
              <span className="so-name">{n.label}</span>
            </div>
          ))}
        </div>
        <div className="so-grp">Excel dosyaları · farklı bilgisayarlardan</div>
        <div className="so-pcs">
          {XL.map(l => (
            <div key={l} className="so-pcitem">
              <Pc />
              <span className="so-name">{l.split(' ')[0]}<br />{l.split(' ').slice(1).join(' ')}</span>
            </div>
          ))}
        </div>
      </div>

      <Link i={2} />

      <div className="so-col">
      <div className="so-card so-cmd" style={{ '--i': 1 }}>
        <div className="so-cmd-h"><span className="so-person"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v11H8l-4 4z" /></svg></span><b>Türkçe komut</b></div>
        <div className="so-chan">
          {CHANNELS.map(([t, ic]) => <div key={t} className="so-chitem">{ic}<span>{t}</span></div>)}
        </div>
      </div>
      <div className="so-vlink" aria-hidden="true"><span /></div>

      <div className="so-hub" style={{ '--i': 3 }}>
        <span className="so-glow" /><span className="so-ring" /><span className="so-ring r2" />
        <div className="so-hub-card">
          <div className="so-hub-logo">
            <svg viewBox="0 0 100 100" aria-hidden="true"><polygon points="4,6 30,6 50,78 70,6 96,6 61,100 39,100" fill="#D0202E" /><polygon points="50,78 61,100 39,100" fill="#96101C" /></svg>
            <b>VİZOVA</b>
          </div>
          <small>Operasyon asistanı</small>
          <p>Okur · eşleştirir · planlar</p>
        </div>
      </div>
      </div>

      <Link i={4} />

      <div className="so-card so-approve" style={{ '--i': 5 }}>
        <span className="so-person">
          <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.6" /><path d="M5 20c.8-3.6 3.5-5.4 7-5.4s6.2 1.8 7 5.4" /></svg>
        </span>
        <h4>İnsan onayı<br />ile ilerler.</h4>
        <div className="so-chip"><Tick />İş planı gösterilir</div>
        <div className="so-chip"><Tick />Kullanıcı onayı alınır</div>
      </div>

      <Link i={6} />

      <div className="so-out">
        {OUT.map(([t, s], i) => (
          <div key={t} className="so-card so-oitem" style={{ '--i': 7 + i }}>
            <span className="so-num">0{i + 1}</span>
            <span className="so-txt"><b>{t}</b><small>{s}</small></span>
            <Chevron />
          </div>
        ))}
      </div>
    </div>
  );
}
